import {Component, DestroyRef, inject, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BehaviorSubject, Observable} from 'rxjs';

@Component({
    selector: 'emm-publish-menus-confirmation-dialog',
    templateUrl: './publish-menus-confirmation-dialog.component.html',
    styleUrls: ['./publish-menus-confirmation-dialog.component.scss'],
    standalone: false
})
export class PublishMenusConfirmationDialogComponent implements OnInit {
    private readonly destroyRef: DestroyRef = inject(DestroyRef);
    includeStores = false;
    eventCount;
    storesIncludedEventCount$ = new BehaviorSubject<number>(null);
    enablePublishButton = true;
    selectedEffectiveDate: Observable<string>;
    selectedLocation: string;
    selectedLocationSet: string;
    canIncludeStores = false;
    isSuperAdmin = false;
    isAdmin = false;
    isCountry = false;
    isNotChainwide = false;
    isLocation = false;
    isCustomLocationSet = false;
    disableIncludeStores = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<PublishMenusConfirmationDialogComponent>
    ) {}

    ngOnInit() {
        this.selectedLocationSet = this.data.selectedLocationSet;
        this.selectedLocation = this.data.selectedLocation;
        this.eventCount = this.data.eventCount;
        this.data.storesIncludedEventCount.then((eventCount) => {
            if (!this.data.countryCode) {
                eventCount > 0 ? this.storesIncludedEventCount$.next(eventCount) :
                    this.storesIncludedEventCount$.next(this.eventCount);
            }
        });
        if (this.data.countryCode) {
            this.selectedLocation = this.data.countryCode;
        }
        this.isCountry = this.selectedLocation === 'US' || this.selectedLocation === 'CA' ||
            this.selectedLocation === 'PR';
        this.isNotChainwide = this.selectedLocationSet !== 'CHAIN';
        this.isLocation = this.selectedLocation ? this.isNumberString(this.selectedLocation) : null;
        this.isCustomLocationSet = this.data.isCustomLocationSet;
        this.canIncludeStores = this.isLocation !== true && this.isNotChainwide;
        if ((this.isCustomLocationSet || this.canIncludeStores) && !(this.isCountry)) {
            this.includeStores = true;
        }
    }

    isNumberString = (value: string): boolean => {
        return !isNaN(Number(value));
    };

    handleIncludeStoresClicked() {
        this.includeStores = !this.includeStores;
        if (this.includeStores === true) {
            this.data.storesIncludedEventCount.then((eventCount) => {
                eventCount > 0 ? this.storesIncludedEventCount$.next(eventCount) :
                    this.storesIncludedEventCount$.next(this.eventCount);
            });
        } else if (this.data.countryCode && this.includeStores === false) {
            this.storesIncludedEventCount$.next(1);
        }
    }

    publish() {
        const result = {
            includeStores: this.includeStores,
            publishMenu: true,
            publishVenue: false,
        };
        if (this.data.venueId) {
            result.publishMenu = false;
            result.publishVenue = true;
        }
        this.dialogRef.close(result);
    }

    closeDialog() {
        this.dialogRef.close(false);
    }
}
